import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header, Footer } from './components/Layout';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import AGB from './pages/AGB';
import Datenschutz from './pages/Datenschutz';
import Impressum from './pages/Impressum';
import './App.css';

function App() {
  useEffect(() => {
    document.title = 'MitGefühl – Coaching und Beratung';
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.remove();
  }, []);
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/angebot/:slug" element={<ServiceDetail />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/impressum" element={<Impressum />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;
